import { type CustomSession, authClient } from "@/lib/auth/auth";

export type AuthState = {
  isAuthenticated: boolean;
  session: CustomSession | null;
};

export async function getAuthContext(): Promise<AuthState> {
  try {
    const { data } = await authClient.getSession();

    return {
      isAuthenticated: !!data?.session,
      session: data as CustomSession | null,
    };
  } catch {
    return {
      isAuthenticated: false,
      session: null,
    };
  }
}
